<template>
    <div class="login-container">
        <div class="register-box" v-show="!registerSuccess">
            <p class="login-title">注册</p>
            <form id="registerForm">
                <input
                    class="input"
                    v-model="nickname"
                    name="nickname"
                    placeholder="用户名"
                    type="text"
                    autocomplete="off"
                    @focus="hideError(0)"
                />
                <div v-if="errorData[0].errorTag" class="error-msg">
                    {{ errorData[0].errorText }}
                </div>
                <input
                    class="input"

                    name="phone"
                    maxlength="11"
                    placeholder="手机号"
                    autocomplete="off"
                    v-model="phone"
                    @focus="hideError(1)"
                    type="text"
                />
                <div v-if="errorData[1].errorTag" class="error-msg">
                    {{ errorData[1].errorText }}
                </div>
                <input
                    class="input"
                    name="idCard"
                    maxlength="18"
                    v-model="idCard"
                    placeholder="身份证"
                    autocomplete="off"
                    @focus="hideError(2)"
                    type="text"
                />
                <div v-if="errorData[2].errorTag" class="error-msg">
                    {{ errorData[2].errorText }}
                </div>
                <input
                    class="input"
                    name="name"
                    v-model="name"
                    placeholder="真实姓名"
                    autocomplete="off"
                    @focus="hideError(3)"
                    type="text"
                />
                <div v-if="errorData[3].errorTag" class="error-msg">
                    {{ errorData[3].errorText }}
                </div>
                <div class="input radio-box">
                    <div class="radio-gender" @click="changeGender(1)">
                        <span
                            class="iconfont"
                            v-html="gender == 1 ? '&#xe6d1;' : '&#xe6ab;'"
                        ></span>
                        <span class="radio-text">男</span>
                    </div>
                    <div class="radio-gender" @click="changeGender(2)">
                        <span
                            class="iconfont"
                            v-html="gender == 2 ? '&#xe6d1;' : '&#xe6ab;'"
                        ></span>
                        <span class="radio-text">女</span>
                    </div>
                </div>
                <input
                    class="input"
                    name="password"
                    v-model="password"
                    placeholder="设置密码"
                    @focus="hideError(4)"
                    type="password"
                />
                <div v-if="errorData[4].errorTag" class="error-msg">
                    {{ errorData[4].errorText }}
                </div>
                <input
                    class="input pwd"
                    name="password1"
                    v-model="password1"
                    placeholder="确认密码"
                    @focus="hideError(5)"
                    type="password"
                />
                <div v-if="errorData[5].errorTag" class="error-msg">
                    {{ errorData[5].errorText }}
                </div>
                <input
                    id="regsiter"
                    type="button"
                    class="login-btn"
                    value="立即提交"
                    @click="submitRegister"
                />
            </form>
        </div>
        <div v-show="registerSuccess" class="register-success">
            <p class="success-icon iconfont">&#xe605;</p>
            <p class="success-text">
                注册成功，{{ timmerStart }}秒后
                <a @click="goLogin" class="success-back" href="javascript:;"
                    >跳转</a
                >到登录页面
            </p>
        </div>
        <div class="eazy-toast-box" style="display:none">
            <h2 class="eazy-toast-title"></h2>
            <p class="eazy-toast-content">您的账号。。。。。</p>
        </div>
        <transition
            enter-active-class="fadeInDown"
            leave-active-class="fadeOutUp"
        >
            <eazy-toast v-show="errtipsFlag">
                <h2 slot="title" class="eazy-toast-title">错误信息:</h2>
                <div class="eazy-toast-detail">{{ errtips }}</div>
            </eazy-toast>
        </transition>
    </div>
</template>

<script>
import { testPhone, testIDcard, testPassword} from "@/common/util";
import eazyToast from "@/components/common/eazytoast";
import { encrypt } from "@/common/aes";
import md5 from "js-md5";
import "@/css/animate.css";

export default {
    data() {
        return {
            gender: 1,
            nickname: "",
            phone: "",
            idCard: "",
            name: "",
            password: "",
            password1: "",
            errorData: [
                {
                    errorText: "",
                    errorTag: false
                },
                {
                    errorText: "",
                    errorTag: false
                },
                {
                    errorText: "",
                    errorTag: false
                },
                {
                    errorText: "",
                    errorTag: false
                },
                {
                    errorText: "",
                    errorTag: false
                },
                {
                    errorText: "",
                    errorTag: false
                }
            ],
            canSubmit: true,
            errtips: "",
            timmer: null,
            timmerInter: null,
            registerSuccess: false,
            timmerStart: 3,
            errtipsFlag: false
        };
    },
    components: {
        eazyToast
    },
    methods: {
        changeGender(type) {
            this.gender = type;
        },
        submitRegister() {
            this.canSubmit = true;
            if (this.nickname.length < 2 || this.nickname.length > 16) {
                this.errorData[0].errorText = "请输入2~16位字符";
                this.errorData[0].errorTag = true;
                this.canSubmit = false;
            }
            if (!testPhone(this.phone)) {
                this.errorData[1].errorText = "请输入正确的手机号";
                this.errorData[1].errorTag = true;
                this.canSubmit = false;
            }
            if (!testIDcard(this.idCard)) {
                this.errorData[2].errorText = "请输入正确的身份证号";
                this.errorData[2].errorTag = true;
                this.canSubmit = false;
            }
            if (this.name.length < 2 || this.name.length > 16) {
                this.errorData[3].errorText = "请输入2~16位字符";
                this.errorData[3].errorTag = true;
                this.canSubmit = false;
            }
            if (!testPassword(this.password)) {
              this.errorData[4].errorText = "请输入10~18位字母、数字、特殊字符组合";
              this.errorData[4].errorTag = true;
              this.canSubmit = false;
            }
            if (this.password1 != this.password || !this.password1) {
                this.errorData[5].errorText = "两次密码不一致";
                this.errorData[5].errorTag = true;
                this.canSubmit = false;
            }
            var gender = "M";
            if (this.gender == 2) {
                gender = "W";
            }
            if (this.canSubmit) {
                this.$ajax({
                    method: "post",
                    url: "userApi/register",
                    data: {
                        nickname: encrypt(this.nickname),
                        phone: encrypt(this.phone),
                        idCard: encrypt(this.idCard),
                        password: encrypt(md5(this.password)),
                        name: encrypt(this.name),
                        sex: gender
                    },
                    success: res => {
                        if (res.code == 200) {
                            this.timmerStart = 3;
                            if (this.timmerInter) {
                                this.registerSuccess = false;
                                clearInterval(this.timmerInter);
                                this.timmerInter = null;
                            }
                            this.registerSuccess = true;
                            this.timmerInter = setInterval(() => {
                                if (this.timmerStart == 0) {
                                    clearInterval(this.timmerInter);
                                    this.timmerInter = null;
                                    this.goLogin();
                                }
                                this.timmerStart--;
                            }, 1000);
                        } else {
                            this.errtips = res.message;
                            this.errtipsFlag = true;
                            if (this.timmer) {
                                clearTimeout(this.timmer);
                                this.timmer = null;
                            }
                            this.timmer = setTimeout(() => {
                                this.errtipsFlag = false;
                                clearTimeout(this.timmer);
                                this.timmer = null;
                            }, 2000);
                        }
                    },
                    error: res => {
                        console.log(res);
                    }
                });
            }
        },
        hideError(index) {
            this.errorData[index].errorTag = false;
        },
        goLogin() {
            this.$router.push({ path: "/login" });
        }
    },
    watch: {
        phone: function(nval, oval) {
            this.phone = nval.replace(/[^0-9.]/g, "");
        }
    }
};
</script>

<style lang="scss" scoped>
.login-container {
    width: 1000px;
    margin: 0 auto;
    font-size: 16px;
    color: #000;
}

.register-box {
    width: 353px;
    background-color: #ffffff;
    box-shadow: 0px 2px 10px 0px rgba(92, 93, 93, 0.33);
    margin: 0 auto;
    margin-top: 80px;
    margin-bottom: 120px;
    text-align: center;
    overflow: hidden;
}

.login-title {
    margin-top: 30px;
    margin-left: 50px;
    font-size: 16px;
    color: #000 !important;
    text-align: left;
}

.input {
    width: 254px;
    height: 34px;
    background-color: #ffffff;
    border: solid 1px #84b0f6;
    margin: 0 auto;
    font-size: 14px;
    text-align: left;
    margin-top: 8px;
    text-indent: 10px;
}

.error {
    border-color: red;
}

.accout {
    margin-top: 10px;
}

.login-btn {
    width: 254px;
    height: 34px;
    background-color: #009cff;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: #fff;
    border: none;
}

.error-msg {
    color: red;
    width: 254px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    text-align: left;
    margin: 0 auto;
}

.register-success {
    width: 353px;
    padding: 200px 0;
    margin: 0 auto;
    text-align: center;
}

.success-icon {
    font-size: 100px !important;
    color: #339933;
}

.success-back {
    color: #339933;
}
.radio-box {
    text-indent: 3px;
    .radio-gender {
        cursor: default;
        display: inline-block;
        span {
            color: #009cff;
            display: inline-block;
            height: 34px;
            font-size: 20px;
            line-height: 34px;
            vertical-align: middle;
        }
        .radio-text {
            display: inline-block;
            font-size: 16px;
            color: #777;
            vertical-align: middle;
            margin-right: 10px;
        }
    }
}
// 消息标题
.eazy-toast-title {
    padding: 10px 0;
    font-size: 18px;
    font-weight: bold;
    color: red;
}
.eazy-toast-detail {
    color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/login/register.vue